"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadImage = void 0;
var _lodash = require("lodash");
var _ = require("./");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var uploadImage = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var file, _ref$handleSuccess, handleSuccess, _ref$handleError, handleError, url, formData, options, _yield$api, data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            file = _ref.file.originFileObj, _ref$handleSuccess = _ref.handleSuccess, handleSuccess = _ref$handleSuccess === void 0 ? _lodash.noop : _ref$handleSuccess, _ref$handleError = _ref.handleError, handleError = _ref$handleError === void 0 ? _lodash.noop : _ref$handleError, url = _ref.url;
            if (file) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            formData = new FormData();
            formData.append('file', file);
            options = {
              method: 'POST',
              headers: {
                'content-type': 'application/x-www-form-urlencoded'
              },
              data: formData,
              url: url
            };
            _context.prev = 6;
            _context.next = 9;
            return (0, _.api)(options);
          case 9:
            _yield$api = _context.sent;
            data = _yield$api.data;
            handleSuccess(file, data);
            return _context.abrupt("return", data);
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](6);
            handleError(_context.t0);
          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 15]]);
  }));
  return function uploadImage(_x) {
    return _ref2.apply(this, arguments);
  };
}();
exports.uploadImage = uploadImage;